import React from 'react';
import Header from './Header';
import Footer from './Footer';

function LegalLayout({kicker,title,updated,children}) {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <section className="page-hero">
          <span className="kicker">{kicker}</span>
          <h1>{title}</h1>
          <p>Last updated {updated}</p>
        </section>
        <section className="section legal">
          {children}
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default LegalLayout;
